/* eslint-disable max-len */
export const initializeClearSaleFingerprint = (): Promise<string> => {
  return new Promise((resolve) => {
    // Gera sessionID (pode ser substituído por uma implementação mais robusta)
    const sessionId = 'CS_' + Math.random().toString(36).substr(2, 9);
    const appKey = process.env.REACT_APP_CLEARSALE_APPKEY;

    // Insere <noscript> para monitoramento de bloqueio do script
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img src="https://device.clearsale.com.br/p/fp.png?sid=${sessionId}&app=${appKey}&ns=1" />`;
    document.body.appendChild(noscript);

    // Insere o script com a função checkUrl
    const script = document.createElement("script");
    script.innerHTML = `
      function checkUrl(url) {
        let request = new XMLHttpRequest();
        request.open("GET", url, true);
        request.send(null);
        request.onerror = () => {
          let req = new XMLHttpRequest();
          req.open("GET", "https://web.fpcs-monitor.com.br/p/fp.png?sid=${sessionId}&app=${appKey}&bl=1", false);
          req.send(null);
        }
      }
      checkUrl("https://device.clearsale.com.br/p/fp.png");
    `;
    document.body.appendChild(script);

    const csdpScript = document.createElement('script');

    csdpScript.innerHTML = `(function(a,b,c,d,e,f,g){
      a['CsdpObject']=e; a[e]=a[e]||function(){
        (a[e].q=a[e].q||[]).push(arguments)
      };
      a[e].l=1*new Date();
      f=b.createElement(c), g=b.getElementsByTagName(c)[0];
      f.async=1; f.src=d; g.parentNode.insertBefore(f,g)
    })(window, document, 'script', '//device.clearsale.com.br/p/fp.js', 'csdp');
    csdp('app','${appKey}');
    csdp('sessionid','${sessionId}');`
    
    document.body.appendChild(csdpScript);

    // Aguarda 3 segundos para a coleta do fingerprint e retorna o sessionId
    setTimeout(() => resolve(sessionId), 3000);
  });
};
